import { setting } from "shared/types/Report";

const useSettingView = (setSetting:React.Dispatch<React.SetStateAction<setting>>) => {

    const onSettingChangeHandler = <T >(type: keyof setting, name:string, value:T) => {
        setSetting(prevSetting => ({
            ...prevSetting,
            [type]:{
                ...prevSetting[type],
                [name]: value
            }
        }));
    }

    return{onSettingChangeHandler};
}

export default useSettingView;